import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6l16 0","key":"svg-0"}],["path",{"d":"M10 12l10 0","key":"svg-1"}],["path",{"d":"M6 18l14 0","key":"svg-2"}]]

/**
 * IconAlignRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYWxpZ24tcmlnaHQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgNmwxNiAwIiAvPgogIDxwYXRoIGQ9Ik0xMCAxMmwxMCAwIiAvPgogIDxwYXRoIGQ9Ik02IDE4bDE0IDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/align-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconAlignRight = createReactComponent('outline', 'align-right', 'AlignRight', __iconNode);

export default IconAlignRight;